/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindLocationQueryResponse } from './FindLocationQueryResponse';
import {
    FindLocationQueryResponseFromJSON,
    FindLocationQueryResponseFromJSONTyped,
    FindLocationQueryResponseToJSON,
} from './FindLocationQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListLocationQueryResponse
 */
export interface ListLocationQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListLocationQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindLocationQueryResponse>}
     * @memberof ListLocationQueryResponse
     */
    data: Array<FindLocationQueryResponse>;
}

/**
 * Check if a given object implements the ListLocationQueryResponse interface.
 */
export function instanceOfListLocationQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListLocationQueryResponseFromJSON(json: any): ListLocationQueryResponse {
    return ListLocationQueryResponseFromJSONTyped(json, false);
}

export function ListLocationQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLocationQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindLocationQueryResponseFromJSON)),
    };
}

export function ListLocationQueryResponseToJSON(value?: ListLocationQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindLocationQueryResponseToJSON)),
    };
}

